<header>
    <div class="logo" routerLink="/main">
        <img src="assets/icons/logo.svg" />
    </div>

    <div class="menu">
        <h3 *ngIf="hasValidOEM() && (hasComponentViewRole() || hasComponentSupportRole())">{{
            languageService.languageJSON.MainDashboard_Components }}</h3>

        <ul *ngIf="hasValidOEM() && (hasComponentViewRole() || hasComponentSupportRole())">
            <li *ngIf="hasComponentViewRole()" routerLink="/components" routerLinkActive="active"
                [ngClass]="{'active-url': componentUrl}">
                <div class="menu-icon">
                    <img src="assets/icons/menu/components.svg" />
                </div>
                <span class="menu-text">
                    {{ languageService.languageJSON.MainDashboard_ComponentOverview }}
                </span>
            </li>
            <li *ngIf="hasValidOEM() && hasComponentSupportRole()" routerLink="/recalled-components"
                routerLinkActive="active" [ngClass]="{'active-url': recalledUrl}">
                <div class="menu-icon">
                    <img id="thief-icon" src="assets/icons/menu/thief.svg" />
                </div>
                <span class="menu-text">
                    {{ languageService.languageJSON.MainDashboard_RecalledComponents }}
                </span>
            </li>
        </ul>

        <h3 *ngIf="hasValidOEM() && hasConfigurationViewRole()">{{ languageService.languageJSON.MainDashboard_Title2 }}
        </h3>

        <ul *ngIf="hasValidOEM() && hasConfigurationViewRole()">
            <li *ngIf="hasConfigurationViewRole()" routerLink="/configurations" routerLinkActive="active"
                [ngClass]="{'active-url': bikeConfigurationUrl}">
                <div class="menu-icon">
                    <img src="assets/icons/menu/configuration.svg" />
                </div>
                <span class="menu-text">
                    {{ languageService.languageJSON.MainDashboard_ConfigurationOverview }}
                </span>
            </li>
            <li *ngIf="hasConfigurationModifyRole()" routerLink="/new-configuration" routerLinkActive="active">
                <div class="menu-icon">
                    <span class="plus-icon">+</span>
                </div>
                <span class="menu-text">
                    {{ languageService.languageJSON.ConfigurationList_CreateNewConfiguration }}
                </span>
            </li>
        </ul>

        <h3 *ngIf="hasValidOEM() && hasSoftwareViewRole()">{{ languageService.languageJSON.MainDashboard_Releases }}
        </h3>

        <ul *ngIf="hasValidOEM() && hasSoftwareViewRole()">
            <li routerLink="/software-overview" routerLinkActive="active" *ngIf="hasSoftwareViewRole()"
                [ngClass]="{'active-url': softwareOverviewUrl}">
                <div class="menu-icon">
                    <img src="assets/icons/menu/release-list.svg" />
                </div>
                <span class="menu-text">
                    {{ languageService.languageJSON.MainDashboard_ReleaseOverview }}
                </span>

            </li>
            <li routerLink="/new-software" routerLinkActive="active" *ngIf="hasSoftwareModifyRole()">
                <div class="menu-icon">
                    <span class="plus-icon">+</span>
                </div>
                <span class="menu-text">
                    {{ languageService.languageJSON.MainDashboard_CreateNewRelease }}
                </span>
            </li>
        </ul>

        <h3 *ngIf="hasValidOEM() && hasBikeViewRole()">{{ languageService.languageJSON.MainDashboard_Inventory }}</h3>

        <ul *ngIf="hasValidOEM() && hasBikeViewRole()">
            <li routerLink="/bike-overview" routerLinkActive="active" [ngClass]="{'active-url': bikeOverviewUrl}">
                <div class="menu-icon">
                    <img src="assets/icons/menu/bicycle.svg" />
                </div>
                <span class="menu-text">
                    {{ languageService.languageJSON.ManageBikes_Title }}
                </span>
            </li>

            <li routerLink="/unassigned-bikes" routerLinkActive="active" *ngIf="hasUnassignedBikesViewRole()">
                <div class="menu-icon">
                    <img id="unassigned-icon" src="assets/icons/menu/broken-link-icon.svg" />
                </div>
                <span class="menu-text">
                    {{ languageService.languageJSON.MainDashboard_UnassignedBikes }}
                </span>
            </li>
        </ul>
    </div>
</header>